import { SsoComponentService } from "./sso-component.service";

export class DefaultSsoComponentService implements SsoComponentService {}
